import { BaseService } from '../../../infra/base.service'
import type { List } from './list'
import type { MoveListDto } from './lists-move.dto'
import type { ListsRepository } from './lists.repository'

export class ListsService extends BaseService<List> {
    constructor(private rep: ListsRepository) {
        super(rep)
    }

    async move(listId: string, moveListDto: MoveListDto) {
        this.rep.move(listId, moveListDto)
    }

    async resetToken(listId: string) {
        this.rep.resetToken(listId)
    }
}
